import { StandardRecordListFilters } from './standard-record-list-filters';
import { StandardRecordListTable } from './standard-record-list-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useAuthentication } from '~/hooks/useAuthentication';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useStandardRecordListQuery } from '../queries';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Button } from '~/components/Button/Button';
import { Link } from '~/components/Link/Link';
import { querySchema } from './query-schema';
import { Fragment } from 'react/jsx-runtime';
import { toIsMaleFilter } from '~/utils/sex';

export const Page = withPrivateRoute(() => {
  const { values } = useFilterForm(querySchema.parse);
  const { can, isSuperUser, user } = useAuthentication();

  const district = isSuperUser ? undefined : user?.permissions.districts_admin[0]?.id;

  const { data = [], isLoading } = useStandardRecordListQuery({
    district: district ?? values.district,
    discipline: values.discipline,
    competition_type: values.competition_type,
    weight_class: values.weight_class,
    is_male: toIsMaleFilter(values.sex),
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Standardrekord" />

        {can('manage-standard-records') && (
          <Link to="create">
            <Button type="button">Skapa ny</Button>
          </Link>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <StandardRecordListFilters />
        <StandardRecordListTable records={data} isLoading={isLoading} />
      </PageLayout.Section>
    </Fragment>
  );
});
